import { render, staticRenderFns } from "./ShortAnswer.vue?vue&type=template&id=4ac3dab8&scoped=true&"
import script from "./ShortAnswer.vue?vue&type=script&lang=js&"
export * from "./ShortAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac3dab8",
  null
  
)

export default component.exports